// @flow

import Decimal from 'decimal.js';

const fixedRoundUp = (num, Uom) => {
  return Math.ceil(new Decimal(num).toDecimalPlaces(5, 1).toNumber() * Uom);
};

const fixedRoundDown = (num, Uom) => {
  return Math.floor(new Decimal(num).toDecimalPlaces(5, 1).toNumber() * Uom);
};

const getBottlesFromQty = (Qty: number, Uom: number, roundDown = false) => {
  const c = parseInt(Qty, 10);

  const decimal = parseFloat(Qty) - c;

  if (roundDown) {
    return fixedRoundDown(decimal, Uom);
  }

  return fixedRoundUp(decimal, Uom);
};

export { getBottlesFromQty };
